import apis from "../../core/apis.js";

class RougenaResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.rougena).get(options);
  }

  get(id) {
    return this.$resource(apis.rougena + id).get();
  }

  search(search = "") {
    return this.$resource(apis.rougena).get({ search });
  }

  post(item) {
    return this.$resource(apis.rougena).save(item);
  }

  update(id, item) {
    return this.$resource(apis.rougena + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  suggestPolygons(options) {
    return this.$resource(apis.rougena + "suggestPolygons").query(options);
  }

  suggestRoute(options) {
    return this.$resource(apis.rougena + "suggestRoute").get(options);
  }

  saveRoute(item) {
    return this.$resource(apis.rougena + "saveRoute").save(item);
  }

  publishRoute(item) {
    return this.$resource(apis.rougena + "publishRoute").save(item);
  }

  getSatisfiedDemand(item) {
    return this.$resource(apis.rougena + "getSatisfiedDemand").save(item);
  }

  getSavedRoutes(options) {
    return this.$resource(apis.rougena + "getSavedRoutes").query(options);
  }

  getRoute(options) {
    return this.$resource(apis.rougena + "getRoute").get(options);
  }
}

export default RougenaResource;



// WEBPACK FOOTER //
// ./src/resources/rougena/rougena.resource.js